export default function (value) {
  return value.split('-')[0];
}
